var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import Inset from "syf-component-library/ui/spacing/Inset";
import Stack from "syf-component-library/ui/spacing/Stack";
import ShowProfileContent from "./ShowProfileContent";
import EditButton from "./subcomponents";
import { PAGE_NAME } from "../../../const/analytics";
import errorCodes from "../../../const/errorCodes";
import { useProfile } from "../../../const/syfApiQueries";
import { useProfileGlobalState } from "../../../context/profileGlobalState";
import getOtpErrorMessage from "../../../helpers/getOtpErrorMessage";
import { removeProfileSessionAction } from "../../../helpers/profileSessionStorage";
import queryParamsToObject from "../../../helpers/queryParamsToObject";
import triggerProfileAnalytics from "../../../helpers/triggerProfileAnalytics";
import { useConfig } from "../../../hooks/useConfig";
import useCurrentAccount from "../../../hooks/useCurrentAccounts";
import useScrollToTop from "../../../hooks/useScrollToTop";
import CardHeader from "../../atoms/CardHeader";
import CustomMessageBox from "../../atoms/CustomMessageBox";
import ProfileRow from "../../molecules/ProfileRow";
import { RowItem } from "../../molecules/subcomponents";
import { CenterContainer, InnerContentWrapper } from "../../subcomponents";
import CustomerName from "../../molecules/ProfileDetails/CustomerName";
import PhoneNumbers from "../../molecules/ProfileDetails/PhoneNumbers";
import Address from "../../molecules/ProfileDetails/Address";
import EmailAddress from "../../molecules/ProfileDetails/EmailAddress";
import Income from "../../molecules/ProfileDetails/Income";
import getTranslation from "../../../strings/getTranslations";
import englishProfileTranslation from "../../../strings/lang/en";
var ShowProfile = function (_a) {
    var goToEditProfile = _a.goToEditProfile;
    var t = getTranslation().t;
    useScrollToTop();
    var _b = useState(""), otpErrorCode = _b[0], setOtpErrorCode = _b[1];
    var otpErrorCallbackParams = sessionStorage.getItem("otpErrorCallbackParams");
    var _c = useProfileGlobalState().state, selectedAccountId = _c.selectedAccountId, didEditMutationSucceeded = _c.didEditMutationSucceeded;
    var accounts = useCurrentAccount(selectedAccountId);
    var selectedAccountOption = accounts.selectedAccountOption;
    var accountId = selectedAccountOption.value || selectedAccountId;
    var profileConfig = useConfig();
    var profileQuery = useProfile(accountId, profileConfig);
    var profileData = profileQuery.data;
    var isEditingLocked = otpErrorCode === errorCodes.accessDenied ||
        otpErrorCode === errorCodes.serverError;
    useEffect(function () {
        if (otpErrorCallbackParams) {
            var errorObjectParams = queryParamsToObject(otpErrorCallbackParams);
            var stepUpError = "";
            if ("error" in errorObjectParams) {
                stepUpError = errorObjectParams.error;
            }
            if (stepUpError) {
                if (stepUpError !== errorCodes.accessDenied) {
                    sessionStorage.removeItem("otpErrorCallbackParams");
                }
                removeProfileSessionAction();
                setOtpErrorCode(stepUpError);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        triggerProfileAnalytics({
            pageName: PAGE_NAME.SHOW_PROFILE,
            messageType: didEditMutationSucceeded
                ? englishProfileTranslation.forms.labels.success
                : "",
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [didEditMutationSucceeded]);
    return (_jsxs(InnerContentWrapper, __assign({ "data-cy": "showProfile" }, { children: [_jsx(Stack, { size: "small" }), _jsxs(ShowProfileContent, { children: [selectedAccountOption && (_jsxs(_Fragment, { children: [_jsx(ProfileRow, { children: _jsx(Inset, __assign({ all: "small" }, { children: _jsx(CardHeader, {}) })) }), _jsx(ProfileRow, { title: " " })] })), otpErrorCode !== "" && (_jsx(CustomMessageBox, { message: t(getOtpErrorMessage(otpErrorCode)) })), didEditMutationSucceeded && (_jsx(CustomMessageBox, { message: t("forms.labels.success"), icon: faCircleCheck, type: "success", size: "small" })), _jsx(ProfileRow, __assign({ title: t("labels.name"), titleSpacingSize: "large" }, { children: _jsx(CustomerName, { data: profileData }) })), _jsx(PhoneNumbers, { data: profileData }), _jsx(ProfileRow, __assign({ title: t("labels.address"), titleSpacingSize: "large" }, { children: _jsx(Address, { data: profileData }) })), _jsx(Stack, { size: "small" }), _jsx(ProfileRow, __assign({ title: t("labels.email"), titleSpacingSize: "large" }, { children: _jsx(EmailAddress, { data: profileData }) })), _jsx(Stack, { size: "small" }), _jsx(ProfileRow, __assign({ title: t("labels.income"), titleSpacingSize: "large" }, { children: _jsx(Income, { data: profileData }) })), _jsx(Stack, { size: "small" }), _jsx(ProfileRow, __assign({ title: " " }, { children: _jsxs(RowItem, { children: [_jsx(Stack, { size: "small" }), _jsx(CenterContainer, { children: _jsx(EditButton, __assign({ buttonType: "primary", type: "button", onClick: goToEditProfile, dataCy: "editInfoButton", "data-type": "profile details", "data-analytics": "clicktrackingevent", "data-reason": "edit information", disabled: isEditingLocked }, { children: t("actions.edit") })) })] }) }))] })] })));
};
export default ShowProfile;
